import { useMemo } from "react"
import { useGetModelNumbers } from "hooks/api/modelNumbers/modelNumbers.hook"
import type { TModelNumber } from "types/modelNumbers.type"

export const WITHOUT_CATEGORY_KEY = "Without category"

export const useWithoutCategoryModelNumbers = () => {
	const { data: modelNumbersData, isLoading } = useGetModelNumbers()

	const availableModelNumbers = useMemo(() => {
		if (!modelNumbersData) return []
		const withoutCategory = modelNumbersData[WITHOUT_CATEGORY_KEY]
		if (!Array.isArray(withoutCategory)) return []
		return withoutCategory as TModelNumber[]
	}, [modelNumbersData])

	const options = useMemo(
		() =>
			availableModelNumbers.map((mn) => ({
				value: mn.id,
				label: mn.model_number,
			})),
		[availableModelNumbers],
	)

	return { availableModelNumbers, options, isLoading }
}
